module.exports = __webpack_public_path__ + "static/img/logo-white.f0c94a4c.png";